import CoAppDataGridListCell from "../../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";

export const pluginGroupColumns = ["actions", "name", "users"];

export const getPluginGroupsColumns = (
	loading,
	handleOpenRemoveGroupConfirmDialog
) => [
	{
		field: "name",
		headerName: "Name",
		sortable: true,
		editable: false,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "users",
		headerName: "Users",
		editable: false,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Users" isUser={true} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "actions",
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						<ThreeDotMenu
							options={[
								{
									name: "Remove",
									optionClickHandler: () => {
										handleOpenRemoveGroupConfirmDialog(params.row);
									}
								},
							]}
						/>
					</div>
				}
				isLoading={loading}
			/>
		),
	},
];